export const config = {
  title: "JRS Remodelling & Construction",
  meta: {
    description:
      "JRS Remodelling & Construction offers high‑quality home renovation, kitchen & bath remodeling, room additions and carpentry services in Griswold and Jewett City, CT.",
    keywords: [
      "Griswold CT remodeling",
      "JRS Remodeling & Construction",
      "kitchen remodeling Griswold",
      "bathroom renovation CT",
      "home addition CT",
      "carpentry services Griswold"
    ],
    author: "JRS Remodelling & Construction",
    canonicalUrl: "https://www.jrsremodelingconstruction.com/",
  },
  sections: {
    header: {
      businessName: "JRS Remodelling & Construction",
    },
    sectionB: {
      heroTitle: "JRS Remodelling & Construction",
      heroSubtitle: "Expert Home Renovations in Griswold, CT",
      learnAboutText: "See Our Projects",
      phoneNumber: "7747783791",
      phoneLabel: "(774) 778‑3791",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1292475721/photo/house-construction-framing-gradating-into-finished-kitchen-build.jpg?s=612x612&w=0&k=20&c=Bej7Uvae4UaukW4kNYlAV9CkjP7-JTYfTNuCpB49x88=",
      cardData: [
        {
          title: "Kitchen & Bath Remodels",
          description:
            "Custom kitchens and bathrooms built to your design and budget.",
        },
        {
          title: "Room Additions & Extensions",
          description:
            "Create more space with well-integrated home additions.",
        },
        {
          title: "Carpentry & Finish Work",
          description:
            "Custom trim, flooring, cabinetry and finish carpentry.",
        },
      ],
      description:
        "Serving Griswold and Jewett City, CT, JRS Remodeling & Construction delivers professional craftsmanship and personalized service for kitchen, bath, home addition, and finish carpentry projects.",
    },
    sectionC: {
      servicesTitle: "Our Capabilities",
      servicesDescription:
        "From full remodels to finish carpentry, we bring your vision to life.",
      cards: [
        {
          title: "Full Remodeling",
          description:
            "Transform kitchens, bathrooms, basements and living spaces.",
          imageSrc: "https://media.istockphoto.com/id/1180902429/photo/beam-stick-built-frame-of-a-new-house-under-construction.jpg?s=612x612&w=0&k=20&c=KdSgLvRXVb1oOqmH5aruF5tymIj1BfufAXQ3qX639Oo=",
          imageAlt: "Remodeling Project",
        },
        {
          title: "Home Additions",
          description:
            "Add space with seamless additions tailored to your home.",
          imageSrc: "https://media.istockphoto.com/id/1413870149/photo/carpenters-on-the-roof-of-new-building-addition.jpg?s=612x612&w=0&k=20&c=gbtPauOajPnQYFqU2b2caj-ViLfF_lvLetjU_l8nuAw=",
          imageAlt: "Home Addition",
        },
        {
          title: "Finish Carpentry",
          description:
            "Custom trim, molding, built-ins and hardwood installations.",
          imageSrc: "https://media.istockphoto.com/id/991867390/photo/that-thing-is-next-on-our-housing-plan.jpg?s=612x612&w=0&k=20&c=7emEOvQq5H6RQl-g1JV1FHXSg_k64ArCIRxdY1zZjBc=",
          imageAlt: "Carpentry Work",
        },
      ],
      otherServicesTitle: "Extra Services",
      otherServicesList: [
        "Deck & Patio Builds",
        "Drywall & Painting",
        "Flooring Installation",
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src:
          "https://www.jrsremodelingconstruction.com/assets/logo-icone-C91m9CR0.png",
        alt: "JRS Construction Team",
      },
      aboutText: [
        "Located in Griswold, CT, JRS Remodelling & Construction is a trusted local contractor with a focus on quality and communication.",
        "We work directly with homeowners and real estate investors to deliver customized, high-value renovation solutions.",
      ],
    },
    sectionE: {
      profileImage: "https://www.jrsremodelingconstruction.com/assets/logo-icone-C91m9CR0.png",
      profileAlt: "JRS Remodeling Logo",
      businessName: "JRS Remodelling & Construction",
      contact: {
        phone: "7747783791",
        phoneLabel: "(774) 778‑3791",
        email: "jrsantos488@gmail.com",
        website: "https://www.jrsremodelingconstruction.com/",
        address: "15 George St Apt 25, Griswold, CT",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "15 George St Apt 25, Griswold, CT",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3028.123456!2d-72.000123!3d41.577890!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e1f8d8a1234567%3A0xabcdef1234567890!2sGriswold%2C+CT+06351!5e0!3m2!1sen!2sus!4v1710000000000!5m2!1sen!2sus",
    },
  },
};

export default config;
